/**
 * Firebase Service Module
 * 
 * This module provides a centralized API for Firebase functionality,
 * including notification handling, token management, and messaging.
 */

import firebase, { requestNotificationPermission, onMessageListener } from './firebase-config';

/**
 * Initialize Firebase notifications
 * Requests permission and gets the FCM token
 * @returns {Promise<string|null>} FCM token if successful, null otherwise
 */
export const initializeFirebase = async () => {
  return requestNotificationPermission();
};

/**
 * Set up a listener for Firebase messages in the foreground
 * @param {Function} callback - Function to call when a message is received
 * @returns {Promise<any>} - Promise that resolves with the message payload
 */
export const setupMessageListener = (callback) => {
  return onMessageListener(callback);
};

/**
 * Get Firebase messaging instance
 * @returns {Object} Firebase messaging instance
 */
export const getMessaging = () => {
  return firebase.messaging();
};

/**
 * Get Firebase app instance
 * @returns {Object} Firebase app instance
 */
export const getFirebaseApp = () => {
  return firebase;
};

const FirebaseService = {
  initializeFirebase,
  setupMessageListener,
  getMessaging,
  getFirebaseApp
};

export default FirebaseService;
